<template>
  <div>
    <!-- MAIN -->
    <div class="breadcrumbs ace-save-state" id="breadcrumbs">
      <ul class="breadcrumb">
        <li>
          <i class="ace-icon fa fa-home home-icon"></i>
          <a href="#/">メインメニュー</a>
        </li>
        <li class="active">ユーザー一括登録</li>
      </ul><!-- /.breadcrumb -->
    </div>
    <!-- END MAIN -->
    <div class="page-header">
      <div class="checkbox">
        <h3>ユーザー一括登録</h3>
      </div>
    </div><!-- /.page-header -->
    <div class="page-content" style="padding-top:100px">
      <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
      <div class="tab-content">
        <div class="row">
          <div class="col-xs-12">
            <div class="alert alert-info">
              ユーザーの登録と個人コードとゲートグループの紐づけをExcelファイルを使用して、一括で実施することができます。<br/>
              登録するために必要なテンプレートExcelファイルは、”テンプレートのダウンロード”から取得して下さい。
            </div>
            <div class="fallback">
              <p class="desc">自分のコンピューターからファイルを選択する ：</p>
              <label for="file_excel" class="btn-upload">
                Excelファイルを選択
                <input type="file" id="file_excel" style="display:none;" ref="myFiles" class="custom-file-input" @change="previewFiles" multiple accept='.xlsx,xls'>
              </label>
              <span class="filename">選択されていません</span>
              <span class="error"></span>
              <div id="result">
              </div>
              <button class="import_excel btn btn-info" type="button" data-toggle="modal" @click="importClick()">
                登録データのアップロード
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="tab-content">
        <div class="row">
          <div class="col-xs-12">
            <div class="alert alert-info">
              <p>ユーザーの登録と個人コードとゲートグループの紐づけを一括で登録するテンプレートファイルをダウンロードできます。</p>
              <br/>
              <p>＜本ファイルで設定可能なデーター＞</p>
              <p>ユーザーの登録</p>
              <p>ユーザーとカード（個人コード）の紐づけ</p>
              <p>ユーザーとゲートグループの紐づけ</p>
              <br/>
              <p>＜SMS認証サービス加入者のみ設定可能なデーター＞</p>
              <p>SMS認証の設定</p>
              <p>携帯電話番号の登録</p>
              <br/>
              <p>ダウンロード前に以下の設定を行って下さい。</p>
              <p>&ensp;・ゲートの設定</p>
              <p>&ensp;・ゲートグループの作成</p>
              <p>&ensp;・ゲートグループへの紐付け</p>
            </div>
            <div class="profile-info-row">
              <button class="export_excel btn btn-info" type="button" @click="exportClick()">テンプレートのダウンロード</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- プロフィールModal -->
    <div id="confirm-lowercase" class="modal fade custom-m" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="smaller lighter frofile-title no-margin">個人コード登録</h3>
          </div>
          <div class="modal-body">
            <div>
              カード番号に半角英字の小文字が含まれております。<br>
              小文字が含まれているとカードが正常に読み込まれません。<br>
              小文字が含まれているかを確認してください。
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-green" style="width:100px" data-dismiss="modal">見直す</button>
            <button class="btn btn-red" style="width:250px" data-dismiss="modal" @click="yesChoiceLowerCase()" >小文字が含まれていても登録する</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div>
    <div id="process" class="modal fade" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <span class="progress-question">登録データのアップロード</span>
            <div class="progress" v-bind:class="{'progress-striped':!success , active:!success}" v-if="exportProgress">
              <div class="progress-bar" :style="progressWidth">
              <span>{{ Math.round(progress) }}%</span>
              </div>
            </div>
            <!-- <span class="success-label" v-if="successItem>0">{{totalDataRow}}件中{{successItem}}件をアップロードしました。</span> -->
            <!-- Sheet 1-->
          <div class="progress-container" >
            <div v-if="importProgress" style="padding-top: 13px">
              <span v-if="sheet1Name">{{sheet1Name}}：</span>
            </div>
            <div class="progress" v-bind:class="{'progress-striped':!successSheet1 , active:!successSheet1}" v-if="importProgress">
              <div class="progress-bar" :style="progressWidthSheet1">
              <span>{{ Math.round(progressSheet1) }}%</span>
              </div>
            </div>
            <span class="success-label" v-if="successItemSheet1>0">{{totalDataRowSheet1}}件中{{successItemSheet1}}件をアップロードしました。</span>
          </div>
            <!-- Sheet 2 -->
          <div class="progress-container" >
            <div v-if="importProgress" style="padding-top: 13px">
              <span v-if="sheet2Name">{{sheet2Name}}：</span>
            </div>
            <div class="progress" v-bind:class="{'progress-striped':!success , active:!success}" v-if="importProgress">
              <div class="progress-bar" :style="progressWidthSheet2">
              <span>{{ Math.round(progressSheet2) }}%</span>
              </div>
            </div>
            <div v-if="message.length !== 0" style="width:100%;padding:10px;border:1px solid #ccc;color:red;margin-top:10px">
              <div v-html="message"></div>
            </div>
            <span class="success-label" v-if="successItemSheet2>0">{{totalDataRowSheet2}}件中{{successItemSheet2}}件をアップロードしました。</span>
          </div>
            <div v-if="errorMessage.length>0">
              <div style="padding-top: 13px">
                <span class="error-box-title">アップロード失敗</span>
              </div>
              <div class="error-box">
                <template v-for="item in errorMessage">
                  <p v-html="item" :key="item"></p>
                </template>
              </div>
            </div>
          </div>
          <div class="modal-footer">
          <button class="btn btn-sm btn-success pull-right" style="width:100px" data-dismiss="modal" v-if="success">OK</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div>
    <!-- プロフィールModal -->
    <div id="question" class="modal fade" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div>
              作成したユーザーのメールアドレスへ通知メールを送信しますか？
            </div>
          </div>
          <div class="modal-footer">
            <button id="yes-choice" class="btn btn-sm btn-success" data-dismiss="modal" @click="yesChoice()">送信する</button>
            <button id="no-choice" class="btn btn-sm" data-dismiss="modal" @click="noChoice()">送信しない</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>
import * as Config from '../../config'
import saveAs from 'file-saver/dist/FileSaver'
import ExcelJS from 'excel4node'
import XLSX from 'xlsx'
export default {
  data () {
    return {
      files: null,
      errorMessage: [],
      importData: [],
      exportData: [],
      isExport: false,
      groupData: null,
      groupDataLoad: 0,
      pagesGroup: 0,
      percent: 0,
      percentSheet1: 0,
      percentSheet2: 0,
      percentGroup: 0,
      progress: 0,
      progressSheet1: 0,
      progressSheet2: 0,
      loadAllPageData: 1,
      totalDataRow: 0,
      successItemSheet1: 0,
      successItemSheet2: 0,
      loading: false,
      success: false,
      successSheet1: false,
      successSheet2: false,
      message: '',
      isSendEmail: false,
      UserSheetImportData: [],
      errorName: '',
      sheet1Name: '',
      sheet2Name: '',
      totalDataRowSheet1: 0,
      totalDataRowSheet2: 0,
      exeCountSheet1: 0,
      exeCountSheet2: 1,
      userCheckListSheet2: [],
      isimportsuccess: false,
      nextpcodeRequest: 0,
      nextgrpUserRequest: 1,
      rowinErrDialog: 0,
      groupGateArray: [],
      userIdArray: [],
      userInGroupMx: [],
      countColumn: 1,
      time0: 0
    }
  },
  watch: {
    'progressWidth': 'checkProgress',
    'progressWidthSheet2': 'checkProgressSheet2',
    groupDataLoad: function (newVal, oldVal) {
      if (newVal === this.pagesGroup) {
        this.downloadCSV()
      } else if (newVal > 0) {
        this.getDataForGroup(newVal + 1)
      }
    },
    exeCountSheet1: function (newVal, oldVal) {
      var vm = this
      if (newVal > 0 && newVal < vm.totalDataRowSheet1) {
        if (vm.UserSheetImportData[newVal][0][0] === undefined || vm.UserSheetImportData[newVal][0][0].length < 4 || vm.UserSheetImportData[newVal][0][0].length > 96) {
          if (newVal % 100 === 0) {
            // prevent infinite warn every 100 row.
            this.$http.get(Config.USERS_LIST_API + '?limit=25&userId=0')
              .then(response => {
                var rowstatus = vm.sheet1Name + 'シート>>' + vm.UserSheetImportData[newVal][1] + '行目>><span>入力したパラメーターが誤っています。入力内容をご確認ください。</span>'
                this.$set(this.errorMessage, vm.rowinErrDialog++, rowstatus)
                vm.exeCountSheet1++
                vm.progressSheet1 += vm.percentSheet1
              })
              .catch((error) => {
                console.log(error)
                var rowstatus = vm.sheet1Name + 'シート>>' + vm.UserSheetImportData[newVal][1] + '行目>><span>入力したパラメーターが誤っています。入力内容をご確認ください。</span>'
                this.$set(this.errorMessage, vm.rowinErrDialog++, rowstatus)
                vm.exeCountSheet1++
                vm.progressSheet1 += vm.percentSheet1
              })
          } else {
            var rowstatus = vm.sheet1Name + 'シート>>' + vm.UserSheetImportData[newVal][1] + '行目>><span>入力したパラメーターが誤っています。入力内容をご確認ください。</span>'
            this.$set(this.errorMessage, vm.rowinErrDialog++, rowstatus)
            vm.exeCountSheet1++
            vm.progressSheet1 += vm.percentSheet1
          }
        } else {
          vm.usereditExe(vm.UserSheetImportData[newVal][0][0], vm.UserSheetImportData[newVal][0][1], vm.UserSheetImportData[newVal][0][2], vm.UserSheetImportData[newVal][0][3], vm.UserSheetImportData[newVal][0][4], vm.UserSheetImportData[newVal][0][5], vm.UserSheetImportData[newVal][0][6], vm.UserSheetImportData[newVal][0][7], vm.UserSheetImportData[newVal][0][8], vm.UserSheetImportData[newVal][0][9], vm.UserSheetImportData[newVal][0][10], vm.UserSheetImportData[newVal][0][11], vm.UserSheetImportData[newVal][0][12], vm.UserSheetImportData[newVal][0][13], vm.UserSheetImportData[newVal][0][14], vm.UserSheetImportData[newVal][0][15], vm.UserSheetImportData[newVal][0][16], vm.UserSheetImportData[newVal][0][17], vm.UserSheetImportData[newVal][1], vm.percent)
        }
      } else if (newVal > 0 && newVal === vm.totalDataRowSheet1) {
        this.exeCountSheet1 = 0
        this.UserSheetImportData = []
        this.successSheet1 = true
        console.log('Finish sheet 1')
        if (vm.userIdArray.length > 0 & vm.groupGateArray.length > 0) {
          // Import Gate Group Sheet
          this.exeCountSheet2 = 0
          this.nextgrpUserRequest = 1
          var grpId = vm.groupGateArray[vm.nextgrpUserRequest]
          var usrId = vm.userIdArray[vm.exeCountSheet2][0]
          vm.gateGrpImportExe(grpId, usrId, vm.userInGroupMx[grpId][usrId], vm.userIdArray[vm.exeCountSheet2][1])
        } else {
          console.log('Sheet 2 have no data')
          this.progressSheet2 = 100
          this.success = true
          this.exeCountSheet2 = 0
          this.nextgrpUserRequest = 1
          this.userIdArray = []
          this.userInGroupMx = []
          this.groupGateArray = []
          this.totalDataRow = 0
        }
      }
    },
    nextpcodeRequest: function (newVal, oldVal) {
      var vm = this
      if (newVal <= 3 && vm.UserSheetImportData.length > 0) {
        var rowno = vm.exeCountSheet1
        console.log(vm.UserSheetImportData[rowno][0])
        switch (newVal) {
          case 1:
            vm.pcodaddExe(vm.UserSheetImportData[rowno][0][0], vm.UserSheetImportData[rowno][0][12], vm.UserSheetImportData[rowno][0][13], vm.UserSheetImportData[rowno][1])
            break
          case 2:
            vm.pcodaddExe(vm.UserSheetImportData[rowno][0][0], vm.UserSheetImportData[rowno][0][14], vm.UserSheetImportData[rowno][0][15], vm.UserSheetImportData[rowno][1])
            break
          case 3:
            vm.pcodaddExe(vm.UserSheetImportData[rowno][0][0], vm.UserSheetImportData[rowno][0][16], vm.UserSheetImportData[rowno][0][17], vm.UserSheetImportData[rowno][1])
            break
          default:
            // Reset nextpcodeRequest
            break
        }
      }
    },
    exeCountSheet2: function (newVal, oldVal) {
      var vm = this
      if (newVal > 0 && newVal < vm.totalDataRowSheet2) {
        var grpId = vm.groupGateArray[vm.nextgrpUserRequest]
        var usrId = vm.userIdArray[newVal][0]
        if (newVal % 100 === 0) {
          // prevent infinite warn every 100 row.
          this.$http.get(Config.USERS_LIST_API + '?limit=25&userId=' + usrId)
            .then(response => {
              vm.gateGrpImportExe(grpId, usrId, vm.userInGroupMx[grpId][usrId], vm.userIdArray[vm.exeCountSheet2][1])
            })
            .catch((error) => {
              console.log(error)
              vm.gateGrpImportExe(grpId, usrId, vm.userInGroupMx[grpId][usrId], vm.userIdArray[vm.exeCountSheet2][1])
            })
        } else {
          vm.gateGrpImportExe(grpId, usrId, vm.userInGroupMx[grpId][usrId], vm.userIdArray[vm.exeCountSheet2][1])
        }
      } else if (newVal > 0 && newVal === vm.totalDataRowSheet2) {
        console.log(((performance.now() - vm.time0) / 1000) / 60)
        this.success = true
        this.exeCountSheet2 = 0
        this.nextgrpUserRequest = 1
        this.userIdArray = []
        this.userInGroupMx = []
        this.groupGateArray = []
      }
    },
    nextgrpUserRequest: function (newVal, oldVal) {
      var vm = this
      if (newVal > 1 && newVal <= vm.groupGateArray.length) {
        var grpId = vm.groupGateArray[newVal]
        var usrId = vm.userIdArray[vm.exeCountSheet2][0]
        if (newVal % 100 === 0) {
          this.$http.get(Config.USERS_LIST_API + '?limit=25&userId=' + usrId)
            .then(response => {
              vm.gateGrpImportExe(grpId, usrId, vm.userInGroupMx[grpId][usrId], vm.userIdArray[vm.exeCountSheet2][1])
            })
            .catch((error) => {
              console.log(error)
              vm.gateGrpImportExe(grpId, usrId, vm.userInGroupMx[grpId][usrId], vm.userIdArray[vm.exeCountSheet2][1])
            })
        } else {
          vm.gateGrpImportExe(grpId, usrId, vm.userInGroupMx[grpId][usrId], vm.userIdArray[vm.exeCountSheet2][1])
        }
      }
    }
  },
  created () {
    this.getPagesGroup()
  },
  mounted () {
    $('#process').on('hidden.bs.modal', this.reset)
  },
  computed: {
    exportProgress: function () {
      if (this.message.length === 0 && this.isExport === true) {
        return true
      } else {
        return false
      }
    },
    importProgress: function () {
      if (this.message.length === 0 && this.isExport === false && this.files !== null) {
        return true
      } else {
        return false
      }
    },
    progressWidth: function () {
      return 'width:' + this.progress + '%'
    },
    progressWidthSheet1: function () {
      return 'width:' + this.progressSheet1 + '%'
    },
    progressWidthSheet2: function () {
      return 'width:' + this.progressSheet2 + '%'
    }
  },
  methods: {
    checkProgress () {
      if (Math.round(this.progress) === 100) {
        // this.success = true
      }
    },
    checkProgressSheet2 () {
      if (Math.round(this.progressSheet2) === 100) {
        this.success = true
      }
    },
    yesChoice () {
      // import
      var vm = this
      vm.isSendEmail = true
      vm.loading = true
      // this.openProgressModal('登録データのアップロード')
      setTimeout(function () {
        vm.importExcel()
      }, 200)
    },
    noChoice () {
      // import
      var vm = this
      vm.isSendEmail = false
      vm.loading = true
      // vm.openProgressModal('登録データのアップロード')
      setTimeout(function () {
        vm.importExcel()
      }, 200)
    },
    yesChoiceLowerCase () {
      var vm = this
      vm.openProgressModal('登録データのアップロード')
      vm.message = ''
      if (vm.UserSheetImportData[0][0] === undefined || vm.UserSheetImportData[0][0][0].length < 4 || vm.UserSheetImportData[0][0][0].length > 96) {
        var rowstatus = vm.sheet1Name + 'シート>> 3行目>><span>入力したパラメーターが誤っています。入力内容をご確認ください。</span>'
        vm.$set(vm.errorMessage, vm.rowinErrDialog++, rowstatus)
        vm.exeCountSheet1++
        vm.progressSheet1 += vm.percentSheet1
      } else {
        vm.usereditExe(vm.UserSheetImportData[0][0][0], vm.UserSheetImportData[0][0][1], vm.UserSheetImportData[0][0][2], vm.UserSheetImportData[0][0][3], vm.UserSheetImportData[0][0][4], vm.UserSheetImportData[0][0][5], vm.UserSheetImportData[0][0][6], vm.UserSheetImportData[0][0][7], vm.UserSheetImportData[0][0][8], vm.UserSheetImportData[0][0][9], vm.UserSheetImportData[0][0][10], vm.UserSheetImportData[0][0][11], vm.UserSheetImportData[0][0][12], vm.UserSheetImportData[0][0][13], vm.UserSheetImportData[0][0][14], vm.UserSheetImportData[0][0][15], vm.UserSheetImportData[0][0][16], vm.UserSheetImportData[0][0][17], 3, vm.percent)
      }
    },
    openConfirmModal (content, yesChoiceText, noChoiceText) {
      $('#question .modal-body>div').html(content)
      $('#yes-choice').html(yesChoiceText)
      $('#no-choice').html(noChoiceText)
      $('#question').modal({
        backdrop: 'static'
      })
    },
    openProgressModal (text) {
      $('.progress-question').html(text)
      $('#process').modal({
        backdrop: 'static',
        keyboard: false
      })
    },
    reset () {
      this.successItemSheet1 = 0
      this.successItemSheet2 = 0
      this.success = false
      location.reload()
    },
    importClick () {
      this.openConfirmModal('作成したユーザーのメールアドレスへ通知メールを送信しますか？', '送信する', '送信しない')
    },
    exportClick () {
      this.openProgressModal('テンプレートのダウンロード進捗状況')
      this.exportExcel()
    },
    previewFiles () {
      this.files = this.$refs.myFiles.files[0]
      $('.filename').html(this.files.name)
    },
    convertStringToBoolean (text) {
      var str = text.trim().toLowerCase()
      switch (str) {
        case '1':
          return true
        case '0':
          return false
        default:
          return false
      }
    },
    usereditExe (userId, password, name, furigana, email, isAdmin, isPhoneAdmin, shareKeyBeValid, isMfaSms, phoneNumber, option1, option2, pcode1type, pCodeId1, pcode2type, pCodeId2, pcode3type, pCodeId3, z) {
      var vm = this
      vm.isimportsuccess = false
      var tmpIsSendEmail = false
      if (email !== null && email !== '') {
        tmpIsSendEmail = vm.isSendEmail
      } else {
        tmpIsSendEmail = false
      }
      var phone = phoneNumber.substring(1)
      var checkMfaSms = vm.convertStringToBoolean(isMfaSms)
      var Infor = []
      var phoneNumberEnd = ''
      if (checkMfaSms === true) {
        if (phoneNumber.match(/^[0][0-9]{10}$/)) {
          phoneNumberEnd = '+81' + phone
        }
        Infor = {
          userId: userId,
          name: name,
          furigana: furigana,
          email: email,
          isSendEmail: tmpIsSendEmail,
          isAdmin: vm.convertStringToBoolean(isAdmin),
          isPhoneAdmin: vm.convertStringToBoolean(isPhoneAdmin),
          shareKeyBeValid: vm.convertStringToBoolean(shareKeyBeValid),
          isMfaSms: vm.convertStringToBoolean(isMfaSms),
          phoneNumber: phoneNumberEnd,
          option1: option1,
          option2: option2
        }
      } else {
        Infor = {
          userId: userId,
          name: name,
          furigana: furigana,
          email: email,
          isSendEmail: tmpIsSendEmail,
          isAdmin: vm.convertStringToBoolean(isAdmin),
          isPhoneAdmin: vm.convertStringToBoolean(isPhoneAdmin),
          shareKeyBeValid: vm.convertStringToBoolean(shareKeyBeValid),
          isMfaSms: vm.convertStringToBoolean(isMfaSms),
          option1: option1,
          option2: option2
        }
      }
      console.log(Infor)
      this.$http.put(Config.USERS_LIST_API + '/' + encodeURIComponent(encodeURIComponent(userId)), Infor)
        .then(response => {
          vm.isimportsuccess = true
          console.log(response)
          vm.nextpcodeRequest++
        })
        .catch((error) => {
          var rowstatus = ''
          switch (error.status) {
            case 400:
              vm.errorName = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              rowstatus = vm.sheet1Name + 'シート>>' + z + ' 行目>>' + userId + '>><span>' + vm.errorName + '</span>'
              this.$set(this.errorMessage, vm.rowinErrDialog++, rowstatus)
              console.log(error)
              vm.nextpcodeRequest++
              break
            case 403:
              vm.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              rowstatus = vm.sheet1Name + 'シート>>' + z + ' 行目>>' + userId + '>><span>' + vm.errorName + '</span>'
              this.$set(this.errorMessage, vm.rowinErrDialog++, rowstatus)
              console.log(error)
              vm.nextpcodeRequest++
              break
            case 404:
              vm.userAddExe(userId, password, name, furigana, email, isAdmin, isPhoneAdmin, shareKeyBeValid, isMfaSms, phoneNumber, option1, option2, z)
              break
            case 401:
              vm.userAddExe(userId, password, name, furigana, email, isAdmin, isPhoneAdmin, shareKeyBeValid, isMfaSms, phoneNumber, option1, option2, z)
              break
            case 500:
              vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              rowstatus = vm.sheet1Name + 'シート>>' + z + ' 行目>>' + userId + '>><span>' + vm.errorName + '</span>'
              this.$set(this.errorMessage, vm.rowinErrDialog++, rowstatus)
              console.log(error)
              vm.nextpcodeRequest++
              break
            case 503:
              vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              rowstatus = vm.sheet1Name + 'シート>>' + z + ' 行目>>' + userId + '>><span>' + vm.errorName + '</span>'
              this.$set(this.errorMessage, vm.rowinErrDialog++, rowstatus)
              console.log(error)
              vm.nextpcodeRequest++
              break
            default:
              vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              rowstatus = vm.sheet1Name + 'シート>>' + z + ' 行目>>' + userId + '>><span>' + vm.errorName + '</span>'
              this.$set(this.errorMessage, vm.rowinErrDialog++, rowstatus)
              console.log(error)
              vm.nextpcodeRequest++
              break
          }
        })
    },
    pcodeeditExe (userId, pCodeId, z) {
      var vm = this
      const Infor = {
        userId: userId
      }
      this.$http.put(Config.PCODE_LIST_API + '/' + encodeURIComponent(pCodeId), Infor)
        .then(response => {
          console.log(response)
          vm.isimportsuccess = true
          if (vm.nextpcodeRequest === 3) {
            vm.exeCountSheet1++
            // console.log(vm.isimportsuccess)
            if (vm.isimportsuccess === true) {
              vm.successItemSheet1++
            }
            vm.progressSheet1 += vm.percentSheet1
            vm.nextpcodeRequest = 0
          } else {
            vm.nextpcodeRequest++
          }
        })
        .catch((error) => {
          switch (error.status) {
            case 401:
              if (error.body.message === 'The incoming token has expired') {
                vm.errorName = ''
              } else {
                vm.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              }
              break
            case 400:
              vm.errorName = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              vm.errorName = '個人コードの編集権限がありません。'
              break
            case 404:
              vm.errorName = '該当するデーターがありません。'
              break
            case 420:
              this.errorMessageLogs = '個人コード登録数が上限に達しています。'
              break
            case 500:
              vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
          }
          var rowstatus = vm.sheet1Name + 'シート>>' + z + ' 行目>> 個人コード: ' + pCodeId + '>><span>' + vm.errorName + '</span>'
          this.$set(this.errorMessage, vm.rowinErrDialog++, rowstatus)
          console.log(error)
          if (vm.nextpcodeRequest === 3) {
            vm.exeCountSheet1++
            // console.log(vm.isimportsuccess)
            if (vm.isimportsuccess === true) {
              vm.successItemSheet1++
            }
            vm.progressSheet1 += vm.percentSheet1
            vm.nextpcodeRequest = 0
          } else {
            vm.nextpcodeRequest++
          }
        })
    },
    pcodaddExe (userId, type, pCodeId, z) {
      var vm = this
      const Infor = {
        userId: userId,
        pCodeId: pCodeId,
        type: parseInt(type),
        isValid: true
      }
      console.log(Infor)
      if (type !== '' && pCodeId !== '') {
        this.$http.post(Config.PCODE_LIST_API, Infor)
          .then(response => {
            console.log(response)
            vm.isimportsuccess = true
            if (vm.nextpcodeRequest === 3) {
              vm.exeCountSheet1++
              // console.log(vm.isimportsuccess)
              if (vm.isimportsuccess === true) {
                vm.successItemSheet1++
              }
              vm.progressSheet1 += vm.percentSheet1
              vm.nextpcodeRequest = 0
            } else {
              vm.nextpcodeRequest++
            }
          })
          .catch((error) => {
            var rowstatus = ''
            switch (error.status) {
              case 401:
                if (error.body.message === 'The incoming token has expired') {
                  vm.errorName = ''
                } else {
                  vm.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                }
                break
              case 400:
                vm.errorName = '入力したパラメーターが誤っています。入力内容をご確認ください。'
                rowstatus = vm.sheet1Name + 'シート>>' + z + ' 行目>>' + pCodeId + '>><span>' + vm.errorName + '</span>'
                this.$set(this.errorMessage, vm.rowinErrDialog++, rowstatus)
                if (vm.nextpcodeRequest === 3) {
                  vm.exeCountSheet1++
                  // console.log(vm.isimportsuccess)
                  if (vm.isimportsuccess === true) {
                    vm.successItemSheet1++
                  }
                  vm.progressSheet1 += vm.percentSheet1
                  vm.nextpcodeRequest = 0
                } else {
                  vm.nextpcodeRequest++
                }
                break
              case 403:
                vm.errorName = '個人コードの追加権限がありません。'
                rowstatus = vm.sheet1Name + 'シート>>' + z + ' 行目>>' + pCodeId + '>><span>' + vm.errorName + '</span>'
                this.$set(this.errorMessage, vm.rowinErrDialog++, rowstatus)
                if (vm.nextpcodeRequest === 3) {
                  vm.exeCountSheet1++
                  // console.log(vm.isimportsuccess)
                  if (vm.isimportsuccess === true) {
                    vm.successItemSheet1++
                  }
                  vm.progressSheet1 += vm.percentSheet1
                  vm.nextpcodeRequest = 0
                } else {
                  vm.nextpcodeRequest++
                }
                break
              case 404:
                vm.errorName = '該当するデーターがありません。'
                rowstatus = vm.sheet1Name + 'シート>>' + z + ' 行目>>' + pCodeId + '>><span>' + vm.errorName + '</span>'
                this.$set(this.errorMessage, vm.rowinErrDialog++, rowstatus)
                if (vm.nextpcodeRequest === 3) {
                  vm.exeCountSheet1++
                  // console.log(vm.isimportsuccess)
                  if (vm.isimportsuccess === true) {
                    vm.successItemSheet1++
                  }
                  vm.progressSheet1 += vm.percentSheet1
                  vm.nextpcodeRequest = 0
                } else {
                  vm.nextpcodeRequest++
                }
                break
              case 409:
                vm.pcodeeditExe(userId, pCodeId, z)
                break
              case 420:
                this.errorMessageLogs = '個人コード登録数が上限に達しています。'
                if (vm.nextpcodeRequest === 3) {
                  vm.exeCountSheet1++
                  // console.log(vm.isimportsuccess)
                  if (vm.isimportsuccess === true) {
                    vm.successItemSheet1++
                  }
                  vm.progressSheet1 += vm.percentSheet1
                  vm.nextpcodeRequest = 0
                } else {
                  vm.nextpcodeRequest++
                }
                break
              case 500:
                vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                rowstatus = vm.sheet1Name + 'シート>>' + z + ' 行目>>' + pCodeId + '>><span>' + vm.errorName + '</span>'
                this.$set(this.errorMessage, vm.rowinErrDialog++, rowstatus)
                if (vm.nextpcodeRequest === 3) {
                  vm.exeCountSheet1++
                  // console.log(vm.isimportsuccess)
                  if (vm.isimportsuccess === true) {
                    vm.successItemSheet1++
                  }
                  vm.progressSheet1 += vm.percentSheet1
                  vm.nextpcodeRequest = 0
                } else {
                  vm.nextpcodeRequest++
                }
                break
              case 503:
                vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                rowstatus = vm.sheet1Name + 'シート>>' + z + ' 行目>>' + pCodeId + '>><span>' + vm.errorName + '</span>'
                this.$set(this.errorMessage, vm.rowinErrDialog++, rowstatus)
                if (vm.nextpcodeRequest === 3) {
                  vm.exeCountSheet1++
                  // console.log(vm.isimportsuccess)
                  if (vm.isimportsuccess === true) {
                    vm.successItemSheet1++
                  }
                  vm.progressSheet1 += vm.percentSheet1
                  vm.nextpcodeRequest = 0
                } else {
                  vm.nextpcodeRequest++
                }
                break
              default:
                vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                rowstatus = vm.sheet1Name + 'シート>>' + z + ' 行目>>' + pCodeId + '>><span>' + vm.errorName + '</span>'
                this.$set(this.errorMessage, vm.rowinErrDialog++, rowstatus)
                if (vm.nextpcodeRequest === 3) {
                  vm.exeCountSheet1++
                  // console.log(vm.isimportsuccess)
                  if (vm.isimportsuccess === true) {
                    vm.successItemSheet1++
                  }
                  vm.progressSheet1 += vm.percentSheet1
                  vm.nextpcodeRequest = 0
                } else {
                  vm.nextpcodeRequest++
                }
                break
            }
            console.log(error)
          })
      } else {
        if (vm.nextpcodeRequest === 3) {
          vm.exeCountSheet1++
          // console.log(vm.isimportsuccess)
          if (vm.isimportsuccess === true) {
            vm.successItemSheet1++
          }
          vm.progressSheet1 += vm.percentSheet1
          vm.nextpcodeRequest = 0
        } else {
          vm.nextpcodeRequest++
        }
      }
    },
    userAddExe (userId, password, name, furigana, email, isAdmin, isPhoneAdmin, shareKeyBeValid, isMfaSms, phoneNumber, option1, option2, z) {
      var vm = this
      var tmpIsSendEmail = false
      if (email !== null && email !== '') {
        tmpIsSendEmail = vm.isSendEmail
      } else {
        tmpIsSendEmail = false
      }
      var phone = phoneNumber.substring(1)
      var checkMfaSms = vm.convertStringToBoolean(isMfaSms)
      var Infor = []
      var phoneNumberEnd = ''
      if (checkMfaSms === true) {
        if (phoneNumber.match(/^[0][0-9]{10}$/)) {
          phoneNumberEnd = '+81' + phone
        }
        Infor = {
          userId: userId,
          password: password,
          name: name,
          furigana: furigana,
          email: email,
          isSendEmail: tmpIsSendEmail,
          isAdmin: vm.convertStringToBoolean(isAdmin),
          isPhoneAdmin: vm.convertStringToBoolean(isPhoneAdmin),
          shareKeyBeValid: vm.convertStringToBoolean(shareKeyBeValid),
          isMfaSms: vm.convertStringToBoolean(isMfaSms),
          phoneNumber: phoneNumberEnd,
          option1: option1,
          option2: option2
        }
      } else {
        Infor = {
          userId: userId,
          password: password,
          name: name,
          furigana: furigana,
          email: email,
          isSendEmail: tmpIsSendEmail,
          isAdmin: vm.convertStringToBoolean(isAdmin),
          isPhoneAdmin: vm.convertStringToBoolean(isPhoneAdmin),
          shareKeyBeValid: vm.convertStringToBoolean(shareKeyBeValid),
          isMfaSms: vm.convertStringToBoolean(isMfaSms),
          option1: option1,
          option2: option2
        }
      }
      console.log(Infor)
      this.$http.post(Config.USERS_LIST_API, Infor)
        .then(response => {
          vm.isimportsuccess = true
          vm.nextpcodeRequest++
          console.log(response)
        })
        .catch((error) => {
          var rowstatus = ''
          switch (error.status) {
            case 401:
              if (error.body.message === 'The incoming token has expired') {
                vm.errorName = ''
              } else {
                vm.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              }
              break
            case 400:
              vm.errorName = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              rowstatus = vm.sheet1Name + 'シート>>' + z + ' 行目>>' + userId + '>><span>' + vm.errorName + '</span>'
              break
            case 403:
              vm.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              rowstatus = vm.sheet1Name + 'シート>>' + z + ' 行目>>' + userId + '>><span>' + vm.errorName + '</span>'
              break
            case 409:
              vm.errorName = '入力されたユーザーIDは既に使用されています。他のユーザーIDを入力してください。'
              rowstatus = vm.sheet1Name + 'シート>>' + z + ' 行目>>' + userId + '>><span>' + vm.errorName + '</span>'
              break
            case 500:
              vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              rowstatus = vm.sheet1Name + 'シート>>' + z + ' 行目>>' + userId + '>><span>' + vm.errorName + '</span>'
              break
            case 503:
              vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              rowstatus = vm.sheet1Name + 'シート>>' + z + ' 行目>>' + userId + '>><span>' + vm.errorName + '</span>'
              break
            default:
              vm.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              rowstatus = vm.sheet1Name + 'シート>>' + z + ' 行目>>' + userId + '>><span>' + vm.errorName + '</span>'
              break
          }
          this.$set(this.errorMessage, vm.rowinErrDialog++, rowstatus)
          vm.nextpcodeRequest++
          console.log(error)
        })
    },
    gateGrpImportExe (groupId, userId, status, rownumber) {
      var vm = this
      if (vm.progressSheet1 === 0) {
        vm.progressSheet1 = 100
        vm.successSheet1 = true
      }
      this.isimportsuccess = false
      var groupPassageId = ''
      userId = userId.toString()
      if (userId === undefined || userId.toString().length < 4 || userId.toString().length > 96) {
        var rowstatus = vm.sheet2Name + 'シート>>' + '>>' + rownumber + ' 行目>><span>入力したパラメーターが誤っています。入力内容をご確認ください。</span>'
        this.$set(this.errorMessage, vm.rowinErrDialog++, rowstatus)
        vm.exeCountSheet2++
        if (vm.isimportsuccess === true) {
          vm.successItemSheet2++
        }
        vm.progressSheet2 += vm.percentSheet2
        vm.nextgrpUserRequest = 1
      } else {
        // Check user
        if (userId in vm.userCheckListSheet2) {
          if (vm.userCheckListSheet2[userId] === 1) { // userid is valid
            if (status === undefined || status === '') { // skip
              vm.isimportsuccess = true
              var inCrease = 1
              if (vm.nextgrpUserRequest === vm.groupGateArray.length - 1) {
                // Next user
                vm.exeCountSheet2++
                if (vm.isimportsuccess === true) {
                  vm.successItemSheet2++
                }
                vm.progressSheet2 += vm.percentSheet2
                vm.nextgrpUserRequest = 1
                inCrease = 0
              }
              setTimeout(() => {
                vm.nextgrpUserRequest = vm.nextgrpUserRequest + inCrease
              }, 300)
            } else if (parseInt(status) === 1 || parseInt(status) === 0) {
              this.$http.get(Config.GROUPS_PASSAGE_API + '?groupId=' + encodeURIComponent(groupId) + '&userId=' + encodeURIComponent(userId))
                .then(response => { // User already belong to the gate group
                  if (response.data.groupPassages.length > 0) {
                    groupPassageId = response.data.groupPassages[0].groupPassageId
                  }
                  if (parseInt(status) === 0) {
                    console.log('Delelte ' + userId + ' from ' + groupId)
                    vm.deleteGroupPassage(groupId, userId, groupPassageId, rownumber)
                  } else if (parseInt(status) === 1) {
                    vm.isimportsuccess = true
                    var inCrease = 1
                    if (vm.nextgrpUserRequest === vm.groupGateArray.length - 1) {
                      // Next user
                      vm.exeCountSheet2++
                      if (vm.isimportsuccess === true) {
                        vm.successItemSheet2++
                      }
                      vm.progressSheet2 += vm.percentSheet2
                      vm.nextgrpUserRequest = 1
                      inCrease = 0
                    }
                    vm.nextgrpUserRequest = vm.nextgrpUserRequest + inCrease
                  }
                })
                .catch((error) => {
                  console.log(error)
                  if (parseInt(status) === 1) {
                    console.log('Add ' + userId + ' to ' + groupId)
                    vm.addGroupPassage(groupId, userId, rownumber)
                  } else if (parseInt(status) === 0) {
                    vm.isimportsuccess = true
                    var inCrease = 1
                    if (vm.nextgrpUserRequest === vm.groupGateArray.length - 1) {
                      // Next user
                      vm.exeCountSheet2++
                      if (vm.isimportsuccess === true) {
                        vm.successItemSheet2++
                      }
                      vm.progressSheet2 += vm.percentSheet2
                      vm.nextgrpUserRequest = 1
                      inCrease = 0
                    }
                    vm.nextgrpUserRequest = vm.nextgrpUserRequest + inCrease
                  }
                })
            } else { // invalid status
              rowstatus = vm.sheet2Name + 'シート>>' + rownumber + ' 行目>>' + groupId + '>>' + userId + '>><span>ステータス値が無効です</span>'
              this.$set(this.errorMessage, vm.rowinErrDialog++, rowstatus)
              inCrease = 1
              if (vm.nextgrpUserRequest === vm.groupGateArray.length - 1) {
                // Next user
                vm.exeCountSheet2++
                if (vm.isimportsuccess === true) {
                  vm.successItemSheet2++
                }
                vm.progressSheet2 += vm.percentSheet2
                vm.nextgrpUserRequest = 1
                inCrease = 0
              }
              setTimeout(() => {
                vm.nextgrpUserRequest = vm.nextgrpUserRequest + inCrease
              }, 300)
            }
          } else if (vm.userCheckListSheet2[userId] === 0) { // user is not exist
            vm.userCheckListSheet2[userId] = 0
            vm.exeCountSheet2++
            if (vm.isimportsuccess === true) {
              vm.successItemSheet2++
            }
            vm.progressSheet2 += vm.percentSheet2
            vm.nextgrpUserRequest = 1
            rowstatus = vm.sheet2Name + 'シート>>' + rownumber + ' 行目>>' + userId + '>><span>ユーザーは存在しません。入力内容をご確認ください。</span>'
            this.$set(this.errorMessage, vm.rowinErrDialog++, rowstatus)
          }
        } else { // need to call api to check user
          this.$http.get(Config.USERS_LIST_API + '?userId=' + encodeURIComponent(userId))
            .then(response => {
              console.log(response)
              vm.userCheckListSheet2[userId] = 1
              if (status === undefined || status === '') { // skip
                vm.isimportsuccess = true
                var inCrease = 1
                if (vm.nextgrpUserRequest === vm.groupGateArray.length - 1) {
                  // Next user
                  vm.exeCountSheet2++
                  if (vm.isimportsuccess === true) {
                    vm.successItemSheet2++
                  }
                  vm.progressSheet2 += vm.percentSheet2
                  vm.nextgrpUserRequest = 1
                  inCrease = 0
                }
                vm.nextgrpUserRequest = vm.nextgrpUserRequest + inCrease
              } else if (parseInt(status) === 1 || parseInt(status) === 0) {
                this.$http.get(Config.GROUPS_PASSAGE_API + '?groupId=' + encodeURIComponent(groupId) + '&userId=' + encodeURIComponent(userId))
                  .then(response => { // User already belong to the gate group
                    if (response.data.groupPassages.length > 0) {
                      groupPassageId = response.data.groupPassages[0].groupPassageId
                    }
                    if (parseInt(status) === 0) {
                      console.log('Delelte ' + userId + ' from ' + groupId)
                      vm.deleteGroupPassage(groupId, userId, groupPassageId, rownumber)
                    } else if (parseInt(status) === 1) {
                      vm.isimportsuccess = true
                      var inCrease = 1
                      if (vm.nextgrpUserRequest === vm.groupGateArray.length - 1) {
                        // Next user
                        vm.exeCountSheet2++
                        if (vm.isimportsuccess === true) {
                          vm.successItemSheet2++
                        }
                        vm.progressSheet2 += vm.percentSheet2
                        vm.nextgrpUserRequest = 1
                        inCrease = 0
                      }
                      vm.nextgrpUserRequest = vm.nextgrpUserRequest + inCrease
                    }
                  })
                  .catch((error) => {
                    console.log(error)
                    if (parseInt(status) === 1) {
                      console.log('Add ' + userId + ' to ' + groupId)
                      vm.addGroupPassage(groupId, userId, rownumber)
                    } else if (parseInt(status) === 0) {
                      vm.isimportsuccess = true
                      var inCrease = 1
                      if (vm.nextgrpUserRequest === vm.groupGateArray.length - 1) {
                        // Next user
                        vm.exeCountSheet2++
                        if (vm.isimportsuccess === true) {
                          vm.successItemSheet2++
                        }
                        vm.progressSheet2 += vm.percentSheet2
                        vm.nextgrpUserRequest = 1
                        inCrease = 0
                      }
                      vm.nextgrpUserRequest = vm.nextgrpUserRequest + inCrease
                    }
                  })
              } else { // invalid status
                rowstatus = vm.sheet2Name + 'シート>>' + rownumber + ' 行目>>' + groupId + '>>' + userId + '>><span>ステータス値が無効です</span>'
                this.$set(this.errorMessage, vm.rowinErrDialog++, rowstatus)
                inCrease = 1
                if (vm.nextgrpUserRequest === vm.groupGateArray.length - 1) {
                  // Next user
                  vm.exeCountSheet2++
                  if (vm.isimportsuccess === true) {
                    vm.successItemSheet2++
                  }
                  vm.progressSheet2 += vm.percentSheet2
                  vm.nextgrpUserRequest = 1
                  inCrease = 0
                }
                vm.nextgrpUserRequest = vm.nextgrpUserRequest + inCrease
              }
            })
            .catch((error) => { // user is not exist
              vm.userCheckListSheet2[userId] = 0
              console.log(error)
              vm.exeCountSheet2++
              if (vm.isimportsuccess === true) {
                vm.successItemSheet2++
              }
              vm.progressSheet2 += vm.percentSheet2
              vm.nextgrpUserRequest = 1
              rowstatus = vm.sheet2Name + 'シート>>' + rownumber + ' 行目>>' + userId + '>><span>ユーザーは存在しません。入力内容をご確認ください。</span>'
              this.$set(this.errorMessage, vm.rowinErrDialog++, rowstatus)
            })
        }
      }
    },
    addGroupPassage (groupId, userId, rownumber) {
      var vm = this
      this.$http.post(Config.GROUPS_PASSAGE_API, {groupId: groupId, userId: userId})
        .then(response => {
          vm.isimportsuccess = true
          if (vm.nextgrpUserRequest === vm.groupGateArray.length - 1) {
            vm.exeCountSheet2++
            if (vm.isimportsuccess === true) {
              vm.successItemSheet2++
            }
            vm.progressSheet2 += vm.percentSheet2
            vm.nextgrpUserRequest = 1
          } else {
            vm.nextgrpUserRequest++
          }
          console.log(response)
        })
        .catch((error) => {
          console.log(error)
          switch (error.status) {
            case 401:
              if (error.body.message === 'The incoming token has expired') {
                this.errorName = ''
              } else {
                vm.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              }
              break
            case 400:
              this.errorName = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
            case 404:
              this.errorName = '該当するデーターがありません。'
              break
            case 409:
              console.log(Config.GROUPS_PASSAGE_API + ':' + groupId + ' ' + userId + ' ' + 'failed')
              this.errorName = '通行権限が重複しています。'
              break
            case 420:
              this.errorName = 'ユーザー登録数が上限に達しています。'
              break
            case 500:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
          }
          var rowstatus = vm.sheet2Name + 'シート>>' + rownumber + ' 行目>>' + groupId + '>>' + userId + '>><span>' + this.errorName + '</span>'
          this.$set(this.errorMessage, vm.rowinErrDialog++, rowstatus)
          if (vm.nextgrpUserRequest === vm.groupGateArray.length - 1) {
            vm.exeCountSheet2++
            if (vm.isimportsuccess === true) {
              vm.successItemSheet2++
            }
            vm.progressSheet2 += vm.percentSheet2
            vm.nextgrpUserRequest = 1
          } else {
            vm.nextgrpUserRequest++
          }
        })
    },
    deleteGroupPassage (groupId, userId, groupPassageId, rownumber) {
      var vm = this
      this.$http.delete(Config.GROUPS_PASSAGE_API + '/' + encodeURIComponent(groupPassageId))
        .then(response => {
          vm.isimportsuccess = true
          if (vm.nextgrpUserRequest === vm.groupGateArray.length - 1) {
            vm.exeCountSheet2++
            if (vm.isimportsuccess === true) {
              vm.successItemSheet2++
            }
            vm.progressSheet2 += vm.percentSheet2
            vm.nextgrpUserRequest = 1
          } else {
            vm.nextgrpUserRequest++
          }
          console.log(response)
        })
        .catch((error) => {
          console.log(error)
          switch (error.status) {
            case 403:
              this.errorName = 'ゲートグループ通行権限の削除権限がありません。'
              break
            case 404:
              this.errorName = '該当するデーターがありません。'
              console.log(groupPassageId)
              break
            case 500:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
          }
          var rowstatus = vm.sheet2Name + 'シート>>' + rownumber + ' 行目>>' + groupId + '>>' + userId + '>><span>' + this.errorName + '</span>'
          this.$set(this.errorMessage, vm.rowinErrDialog++, rowstatus)
          if (vm.nextgrpUserRequest === vm.groupGateArray.length - 1) {
            vm.exeCountSheet2++
            if (vm.isimportsuccess === true) {
              vm.successItemSheet2++
            }
            vm.progressSheet2 += vm.percentSheet2
            vm.nextgrpUserRequest = 1
          } else {
            vm.nextgrpUserRequest++
          }
        })
    },
    importExcel () {
      var vm = this
      vm.time0 = performance.now()
      if (this.files !== null) {
        this.progressSheet1 = 0
        this.progressSheet2 = 0
        this.errorMessage = []
        this.exeCountSheet2 = 0
        this.successItemSheet1 = 0
        this.successItemSheet2 = 0
        this.nextgrpUserRequest = 1
        this.userIdArray = []
        this.userInGroupMx = []
        this.groupGateArray = []
        this.totalDataRow = 0
        var reader = new FileReader()
        reader.onload = function () {
          var data = reader.result
          this.message = ''
          /* convert from array of arrays to workbook */
          var workbook = XLSX.read(data, {type: 'array'})
          vm.sheet1Name = workbook.SheetNames[0]
          vm.sheet2Name = workbook.SheetNames[1]
          var usersheetdata = workbook.Sheets[vm.sheet1Name]
          var gatesheetdata = workbook.Sheets[vm.sheet2Name]
          vm.loading = false
          let isHasLowerCase = false
          if (usersheetdata !== undefined && gatesheetdata !== undefined) {
            var usersheetarray = XLSX.utils.sheet_to_json(usersheetdata, {header: 1})
            var gatesheetarray = XLSX.utils.sheet_to_json(gatesheetdata, {header: 1})
            var headerarray = usersheetarray[1]
            var gateheaderarray = gatesheetarray[1]
            const isEmptyFirstColumnUser = (headerarray[0] === undefined)
            usersheetarray.forEach((value) => {
              if (isEmptyFirstColumnUser) {
                if (value[0] === undefined) {
                  value.splice(0, 1)
                }
              }
              for (let i = 0; i < value.length; i++) {
                if (value[i] === undefined || value[i].toString().trim().length === 0) {
                  value[i] = ''
                }
              }
            })
            const isEmptyFirstColumnGate = (gateheaderarray[0] === undefined)
            gatesheetarray.forEach((value) => {
              if (isEmptyFirstColumnGate) {
                if (value[0] === undefined) {
                  value.splice(0, 1)
                }
              }
              for (let i = 0; i < value.length; i++) {
                if (value[i] === undefined || value[i].toString().trim().length === 0) {
                  value[i] = ''
                }
              }
            })
            if (headerarray.length === 18 && gatesheetarray.length !== 0) {
              for (let index = 2; index < usersheetarray.length; index++) {
                var itemArr = []
                if (usersheetarray[1].length === 18) {
                  var rowIsblank = true
                  for (let headeridx = 0; headeridx < 18; headeridx++) {
                    itemArr[headeridx] = (usersheetarray[index][headeridx] === undefined) ? '' : usersheetarray[index][headeridx] + ''
                    if (itemArr[headeridx] !== '') {
                      rowIsblank = false
                    }
                  }
                  if (rowIsblank === false) {
                    if (itemArr[13].toUpperCase() !== itemArr[13] || itemArr[15].toUpperCase() !== itemArr[15] || itemArr[17].toUpperCase() !== itemArr[17]) {
                      isHasLowerCase = true
                    }
                    vm.UserSheetImportData.push([itemArr, index + 1])
                  }
                }
              }
              // Sheet2
              if (gatesheetarray[2][1] !== undefined && gatesheetarray[2][1].match(/^[0-9a-fA-F-]{36}$/)) {
                vm.groupGateArray = gatesheetarray[2] // Array key start from 1.
              }
              if (vm.groupGateArray.length > 0) {
                for (let index = 0; index < gatesheetarray.length - 3; index++) {
                  if (gatesheetarray[index + 3][0] !== undefined && (gatesheetarray[index + 3][0].toString() !== '')) {
                    var noStatusData = true
                    for (let gridx = 1; gridx < vm.groupGateArray.length; gridx++) {
                      if (gatesheetarray[(index + 4) - 1][gridx] !== undefined && gatesheetarray[(index + 4) - 1][gridx] !== '') {
                        noStatusData = false
                      }
                    }
                    if (noStatusData === false) {
                      vm.userIdArray.push([gatesheetarray[index + 3][0], index + 4])
                    }
                  }
                }
              }
              if (vm.userIdArray.length > 0 && vm.groupGateArray.length > 0) {
                for (let gridx = 1; gridx < vm.groupGateArray.length; gridx++) {
                  var tempArray = []
                  for (let uidx = 0; uidx < vm.userIdArray.length; uidx++) {
                    // if (vm.userIdArray[uidx][0] in tempArray) {
                    //   if (gatesheetarray[vm.userIdArray[uidx][1] - 1][gridx] !== undefined) {
                    //     tempArray[vm.userIdArray[uidx][0]] = gatesheetarray[vm.userIdArray[uidx][1] - 1][gridx]
                    //   } else {
                    //     // do nothing
                    //   }
                    // } else {
                    tempArray[vm.userIdArray[uidx][0]] = gatesheetarray[vm.userIdArray[uidx][1] - 1][gridx]
                    // }
                  }
                  vm.userInGroupMx[vm.groupGateArray[gridx]] = tempArray
                }
              }
              vm.totalDataRowSheet2 = vm.userIdArray.length
              vm.totalDataRowSheet1 = vm.UserSheetImportData.length
              vm.totalDataRow = vm.totalDataRowSheet1 + vm.totalDataRowSheet2
              vm.percentSheet1 = (100 / (vm.totalDataRowSheet1))
              vm.percentSheet2 = (100 / vm.totalDataRowSheet2)
              console.log('Total data row: ' + vm.totalDataRow)
              console.log(vm.UserSheetImportData)
              var rowstatus = ''
              if (vm.totalDataRow > 0) {
                if (vm.totalDataRowSheet1 > 0) {
                  if (isHasLowerCase) {
                    $('#confirm-lowercase').modal({
                      backdrop: 'static'
                    })
                  } else {
                    vm.openProgressModal('登録データのアップロード')
                    vm.message = ''
                    if (vm.UserSheetImportData[0][0] === undefined || vm.UserSheetImportData[0][0][0].length < 4 || vm.UserSheetImportData[0][0][0].length > 96) {
                      rowstatus = vm.sheet1Name + 'シート>> 3行目>><span>入力したパラメーターが誤っています。入力内容をご確認ください。</span>'
                      vm.$set(vm.errorMessage, vm.rowinErrDialog++, rowstatus)
                      vm.exeCountSheet1++
                      vm.progressSheet1 += vm.percentSheet1
                    } else {
                      vm.usereditExe(vm.UserSheetImportData[0][0][0], vm.UserSheetImportData[0][0][1], vm.UserSheetImportData[0][0][2], vm.UserSheetImportData[0][0][3], vm.UserSheetImportData[0][0][4], vm.UserSheetImportData[0][0][5], vm.UserSheetImportData[0][0][6], vm.UserSheetImportData[0][0][7], vm.UserSheetImportData[0][0][8], vm.UserSheetImportData[0][0][9], vm.UserSheetImportData[0][0][10], vm.UserSheetImportData[0][0][11], vm.UserSheetImportData[0][0][12], vm.UserSheetImportData[0][0][13], vm.UserSheetImportData[0][0][14], vm.UserSheetImportData[0][0][15], vm.UserSheetImportData[0][0][16], vm.UserSheetImportData[0][0][17], 3, vm.percent)
                    }
                  }
                } else if (vm.totalDataRowSheet2 > 0) {
                  vm.openProgressModal('登録データのアップロード')
                  this.exeCountSheet2 = 0
                  this.nextgrpUserRequest = 1
                  var grpId = vm.groupGateArray[vm.nextgrpUserRequest]
                  var usrId = vm.userIdArray[vm.exeCountSheet2][0]
                  var rownumber = vm.userIdArray[vm.exeCountSheet2][1]
                  console.log('sheet1 is empty!')
                  vm.gateGrpImportExe(grpId, usrId, vm.userInGroupMx[grpId][usrId], rownumber)
                }
              } else {
                vm.openProgressModal('登録データのアップロード')
                vm.success = true
                vm.message = '不正なファイルです。正しいファイルを選択しなおしてください。'
              }
            } else {
              vm.openProgressModal('登録データのアップロード')
              vm.success = true
              vm.message = '不正なファイルです。正しいファイルを選択しなおしてください。'
            }
          } else {
            vm.openProgressModal('登録データのアップロード')
            vm.success = true
            vm.message = '不正なファイルです。正しいファイルを選択しなおしてください。'
          }
        }
        reader.onerror = function () {
          vm.loading = false
          vm.openProgressModal('登録データのアップロード')
          vm.success = true
          vm.message = '選択されているファイルの読み込みに失敗しました。<br>ブラウザの更新、もしくは別ファイルを選択してから <br> 再度アップロードしたいファイルを選択してください。'
        }
        reader.readAsArrayBuffer(this.files)
      } else {
        vm.openProgressModal('登録データのアップロード')
        vm.loading = false
        vm.success = true
        vm.message = 'XLSXのファイルを選択してください。'
      }
    },
    exportExcel () {
      var vm = this
      this.isExport = true
      this.progress = 0
      if (vm.pagesGroup > 0) {
        vm.getDataForGroup(1)
      } else {
        vm.message = '少なくとも１つ以上グループを作成して下さい。'
        $('#error-alert').fadeTo(2000, 500).slideUp(500, function () {
          $('#error-alert').slideUp(500)
        })
        this.success = true // display button OK to refresh and reset data
      }
    },
    getDataForGroup (page) {
      var vm = this
      this.$http.get(Config.GROUPS_LIST_API + '?limit=1000&page=' + page)
        .then(response => {
          console.log(response)
          vm.groupDataLoad++
          this.groupData = response.body.groups
          this.groupData.forEach(function (item) {
            vm.exportData.push({
              groupId: item.groupId,
              name: item.name
            })
          })
          vm.progress += vm.percentGroup
        })
        .catch(error => {
          vm.progress += vm.percentGroup
          console.log(error)
        })
    },
    getPagesGroup () {
      var vm = this
      this.$http.get(Config.GROUPS_LIST_API)
        .then(response => {
          vm.loadAllPageData++
          if (response.body.maxRecords > 0) {
            vm.pagesGroup = Math.ceil((response.body.maxRecords) / 1000)
            vm.percentGroup = (100 / (vm.pagesGroup))
          }
          console.log(response)
        })
        .catch(error => {
          console.log(error)
        })
    },
    convertArrayOfObjectsToCSV (args) {
      var result, ctr, keys, columnDelimiter, lineDelimiter, data
      data = args.data || null
      if (data == null || !data.length) {
        return null
      }
      columnDelimiter = args.columnDelimiter || ','
      lineDelimiter = args.lineDelimiter || '\n'
      keys = Object.keys(data[0])
      result = ''
      result += keys.join(columnDelimiter)
      result += lineDelimiter
      data.forEach(function (item) {
        ctr = 0
        keys.forEach(function (key) {
          if (ctr > 0) result += columnDelimiter
          result += item[key]
          ctr++
        })
        result += lineDelimiter
      })
      return result
    },
    downloadCSV () {
      var password = '!@#' + Math.random().toString(36).substring(7) + Date.now()
      var vm = this
      // var filename
      var data = vm.exportData
      var wb = new ExcelJS.Workbook()
      var totalLine = 1002
      var options1 = {
        sheetFormat: {
          defaultColWidth: 13
        }
      }
      var options2 = {
        sheetFormat: {
          defaultColWidth: 3
        }
      }
      var options3 = {
        'sheetProtection': {
          'password': password
        },
        'hidden': true
      }
      var sheetNameExport = ['ユーザーとカードの設定', 'ゲートグループとユーザーの紐づけ', '参照']
      var ws1 = wb.addWorksheet(sheetNameExport[0], options1)
      var ws2 = wb.addWorksheet(sheetNameExport[1], options2)
      var ws3 = wb.addWorksheet(sheetNameExport[2], options3)
      var style1 = wb.createStyle({
        alignment: {
          vertical: 'center',
          horizontal: 'left',
          wrapText: true
        }
      })
      var styleFormat = wb.createStyle({
        fill: {
          type: 'pattern',
          patternType: 'solid',
          bgColor: 'FFC008'
        },
        font: {
          color: '000000',
          name: 'MS PGothic'
        }
      })
      var styleBorder = wb.createStyle({
        font: {
          size: 11,
          name: 'MS PGothic'
        },
        border: {
          left: {
            style: 'thin',
            color: '000000'
          },
          right: {
            style: 'thin',
            color: '000000'
          },
          top: {
            style: 'thin',
            color: '000000'
          },
          bottom: {
            style: 'thin',
            color: '000000'
          }
        }
      })
      var styleSheet3 = wb.createStyle({
        alignment: {
          vertical: 'center',
          horizontal: 'center'
        },
        font: {
          size: 11,
          name: 'MS PGothic'
        },
        border: {
          left: {
            style: 'thin',
            color: '000000'
          },
          right: {
            style: 'thin',
            color: '000000'
          },
          top: {
            style: 'thin',
            color: '000000'
          },
          bottom: {
            style: 'thin',
            color: '000000'
          }
        }
      })
      var B2 = [
        {
          color: '000000',
          size: 11,
          value: 'ユーザーID \n',
          name: 'MS PGothic'
        },
        {
          value: '（重複不可）\n',
          bold: true,
          size: 11,
          color: '000000',
          name: 'MS PGothic'
        },
        {
          value: '（半角英数字）',
          size: 9,
          color: 'ff0000',
          name: 'MS PGothic',
          bold: false
        }
      ]
      var C2 = [
        'ログインパスワード',
        {
          value: '（新規ユーザー登録のみ有効）\n',
          bold: true,
          size: 11,
          color: '000000',
          name: 'MS PGothic'
        },
        {
          value: '（必須：半角英大文字+半角英小文字+半角数字の組み合わせ）',
          size: 9,
          color: 'ff0000',
          name: 'MS PGothic',
          bold: false
        }
      ]
      var M2 = [
        '個人コード1 \n',
        {
          value: '（テンキー:半角数字）（NFC:半角英数字）',
          size: 9,
          color: 'ff0000',
          name: 'MS PGothic'
        }
      ]
      var O2 = [
        '個人コード2 \n',
        {
          value: '（テンキー:半角数字）（NFC:半角英数字）',
          size: 9,
          color: 'ff0000',
          name: 'MS PGothic'
        }
      ]
      var Q2 = [
        '個人コード3 \n',
        {
          value: '（テンキー:半角数字）（NFC:半角英数字）',
          size: 9,
          color: 'ff0000',
          name: 'MS PGothic'
        }
      ]
      var C1 = [
        'ゲートグループ一覧 ',
        {
          value: '※紐づけ設定　1：設定、0：解除',
          color: 'ff0000',
          name: 'MS PGothic'
        }
      ]
      var A1 = [
        '※赤セルの箇所は、',
        {
          value: '入力必須項目',
          bold: true,
          size: 11,
          color: '000000',
          name: 'MS PGothic'
        },
        {
          value: 'です \n',
          bold: false,
          size: 11,
          color: '000000',
          name: 'MS PGothic'
        },
        {
          value: '※青セルの箇所は、',
          bold: false,
          size: 11,
          color: '000000',
          name: 'MS PGothic'
        },
        {
          value: 'サービス加入者のみ入力可能',
          bold: true,
          size: 11,
          color: '000000',
          name: 'MS PGothic'
        },
        {
          value: 'です',
          bold: false,
          size: 11,
          color: '000000',
          name: 'MS PGothic'
        }
      ]
      // Sheet 3
      ws3.cell(2, 2)
        .string('ゲートグループの値')
        .style(styleSheet3)
      ws3.cell(3, 2)
        .string(' ')
        .style(styleSheet3)
      ws3.cell(4, 2)
        .number(0)
        .style(styleSheet3)
      ws3.cell(5, 2)
        .number(1)
        .style(styleSheet3)
      ws3.column(2).setWidth(22)
      // Sheet 1
      ws1.cell(1, 2, 1, 5, true)
        .string(A1)
        .style({
          alignment: {
            vertical: 'center',
            horizontal: 'left',
            wrapText: true
          },
          font: {
            size: 11,
            name: 'MS PGothic'
          }
        })
      ws1.row(1).setHeight(31)
      ws1.cell(2, 2)
        .string(B2)
        .style(style1)
      ws1.cell(2, 3)
        .string(C2)
        .style(style1)
      ws1.cell(2, 4)
        .string('ユーザー名')
        .style(style1)
      ws1.cell(2, 5)
        .string('ふりがな')
        .style(style1)
      ws1.cell(2, 6)
        .style(style1)
        .string('メールアドレス')
        .style(style1)
      ws1.cell(2, 7)
        .string('組織管理権限(1:有効.0:無効)')
        .style(style1)
      ws1.cell(2, 8)
        .string('ゲート設定権限ステータス(1:有効.0:無効)')
        .style(style1)
      ws1.cell(2, 9)
        .string('鍵共有権限ステータス(1:有効.0:無効)')
        .style(style1)
      ws1.cell(2, 10)
        .string('SMS認証(1:有効.0:無効)')
        .style(style1)
      ws1.cell(2, 11)
        .string(
          [
            '電話番号 \n',
            {
              value: '（-(ハイフン)無しの携帯電話番号）',
              size: 11,
              color: 'ff0000',
              name: 'MS PGothic'
            }
          ])
        .style(style1)
      ws1.cell(2, 12)
        .string('備考1')
        .style(style1)
      ws1.cell(2, 13)
        .string('備考2')
        .style(style1)
      ws1.cell(2, 14)
        .string('個人コード1-種別（1:テンキー.0：NFCカード）')
        .style(style1)
      ws1.cell(2, 15)
        .string(M2)
        .style(style1)
      ws1.cell(2, 16)
        .string('個人コード2-種別（1:テンキー.0：NFCカード）')
        .style(style1)
      ws1.cell(2, 17)
        .string(O2)
        .style(style1)
      ws1.cell(2, 18)
        .string('個人コード3-種別（1:テンキー.0：NFCカード）')
        .style(style1)
      ws1.cell(2, 19)
        .string(Q2)
        .style(style1)
      ws1.cell(2, 2, totalLine, 4, false)
        .style({
          fill: {
            type: 'pattern',
            patternType: 'solid',
            bgColor: 'fcd5b4',
            fgColor: 'fcd5b4'
          }
        })
      ws1.cell(3, 2, totalLine, 19, false)
        .style({
          alignment: {
            vertical: 'center',
            horizontal: 'left'
          }
        })
      ws1.cell(2, 7, totalLine, 9, false)
        .style({
          fill: {
            type: 'pattern',
            patternType: 'solid',
            bgColor: 'fcd5b4',
            fgColor: 'fcd5b4'
          }
        })
      ws1.cell(2, 10, totalLine, 11, false)
        .style({
          fill: {
            type: 'pattern',
            patternType: 'solid',
            bgColor: 'daeef3',
            fgColor: 'daeef3'
          }
        })
      ws1.cell(3, 11, totalLine, 11, false)
        .style({
          numberFormat: '@'
        })
      // Set border
      ws1.cell(2, 2, totalLine, 19, false)
        .style(styleBorder)
      // set width for column
      ws1.column(12).setWidth(34)
      ws1.column(14).setWidth(34)
      ws1.column(16).setWidth(34)
      ws1.column(1).setWidth(3)
      // sheet 2
      ws2.cell(2, 2)
        .string('ユーザーID')
      ws2.cell(3, 2)
        .string('編集禁止')
        .style({
          alignment: {
            vertical: 'center',
            horizontal: 'right'
          }
        })
      data.forEach((value, index) => {
        var cell = index + 3
        ws2.cell(2, cell)
          .string(value['name'])
          .style({
            alignment: {
              textRotation: 90,
              vertical: 'center',
              horizontal: 'center'
            }
          })
        ws2.cell(3, cell)
          .string(value['groupId'])
          .style({
            alignment: {
              textRotation: 90,
              vertical: 'center',
              horizontal: 'center'
            },
            fill: {
              type: 'pattern',
              patternType: 'solid',
              bgColor: '808080',
              fgColor: '808080'
            }
          })
        for (var i = 3; i <= totalLine; i++) {
          var cellValue = sheetNameExport[0] + '!B' + i
          ws2.cell(i + 1, cell)
            .string('')
          ws2.cell(i + 1, 2)
            .formula('IF( ' + cellValue + '= "", "", ' + cellValue + ')')
            .style({
              alignment: {
                vertical: 'center',
                horizontal: 'left'
              }
            })
        }
        this.countColumn++
      })
      var getColumn = ExcelJS.getExcelCellRef(totalLine + 1, this.countColumn + 1)
      // Set border
      ws2.cell(2, 2, totalLine + 1, this.countColumn + 1, false)
        .style(styleBorder)
      ws2.cell(1, 3)
        .string(C1)
        .style({
          alignment: {
            vertical: 'center',
            horizontal: 'left'
          },
          font: {
            name: 'MS PGothic'
          }
        })
      ws2.addDataValidation({
        type: 'list',
        allowBlank: true,
        showDropDown: true,
        sqref: 'C4:' + getColumn,
        formulas: ['=' + sheetNameExport[2] + '!$B$3:$B$5']
      })
      ws2.cell(2, 2).style({
        alignment: {
          vertical: 'center',
          horizontal: 'left'
        }
      })
      // set default data
      ws2.cell(4, 3, totalLine + 1, this.countColumn + 1)
        .style({
          fill: {
            type: 'pattern',
            patternType: 'solid',
            bgColor: 'bfbfbf',
            fgColor: 'bfbfbf'
          }
        })
      ws2.column(2).setWidth(24)
      ws2.row(3).hide()
      ws2.addConditionalFormattingRule('C4:' + getColumn, {
        type: 'expression',
        priority: 1,
        formula: 'NOT(ISERROR(SEARCH("1",C4:' + getColumn + ')))',
        style: styleFormat
      })
      wb.writeToBuffer().then(function (buffer) {
        const blob = new Blob([buffer])
        saveAs(blob, 'alluser-data.xlsx')
        setTimeout(function () {
          vm.success = true
        }, 200)
      })
    }
  }
}
</script>

<style>
.btn-upload{
  color: white;
  background-color: #000;
  padding: 6px 15px;
  border-radius: 12px;
  cursor: pointer;
  display: inline-block;
  margin: 0px 15px
}
.desc{
  display: inline-block;
  font-size: 15px;
  font-weight: bold;
}
.filename{
  display: inline-block;
}
.modal-title {
  display: initial;
}
.modal-header .close {
  font-size: 22px;
}
/* .yes-choice {
  width:100px;
  background-color: #de8b7c !important;
  border-color: #de8b7c !important;
}
.yes-choice:hover {
  background-color: #d15b47 !important;
  border-color: #d15b47 !important;
}
.no-choice {
  width:100px;
  background-color: #3a3a3a !important;
  border-color: #3a3a3a !important;
}
.no-choice:hover {
  background-color: #000000 !important;
  border-color: #000000 !important;
} */
.import_excel {
  width: 216px
}
.export_excel {
  display: inline-block;
  margin: 5px 0;
}
.color-red {
  color: red;
}
.btn-red {
  background-color: red !important;
  border-color: transparent !important;
}
.btn-green {
  background-color: green !important;
  border-color: transparent !important;
}
</style>



// WEBPACK FOOTER //
// src/views/user-register/UserRegister.vue